import React from 'react';
import InitializingState from '~/app/shared/table3tools/components/InitializingState';

interface Props {
    hasInitialized: boolean;
    children?: React.ReactNode;
}

export default function EmptyStateInitializer({ hasInitialized, children }: Props): React.JSX.Element | null {
    if (!hasInitialized) {
        return <InitializingState />;
    }

    // funnel all all subtypes of ReactNode other than ReactChild | ReactFragment | ReactPortal to null
    if (children === true || children === false || children === undefined || children === null) {
        return null;
    }

    return <>{children}</>;
}
